import React from 'react';
import { Col , Button, Row} from '@themesberg/react-bootstrap';
import {
  FilterRow,
  StyledFormGroup,
  StyledFormLabel,
  StyledFormControl,
  TableBg,
  CustomCol,
  StyledSelect

} from '../../../../components/StyledComponents';
import { StaffStatus } from '../constants';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRedoAlt } from "@fortawesome/free-solid-svg-icons";



const StaffFilter = ({ search, setSearch, searchRegEx, setPage, customColSetting, staffStatus, setStaffStatus,
  staffRole, setStaffRole,
  adminRoles, onHandleResetFilter }) => {
  const handleSearchChange = (event) => {
    setPage(1);
    const mySearch = event.target.value.replace(searchRegEx, "");
    setSearch(mySearch);
  };



  return (
    <TableBg>
      <FilterRow>
        <Col xs={12} md={3} lg={3}>
          <div className="d-flex flex-column  justify-content-between flex-md-row gap-3">
            {/* Search Input */}
            <div className="flex-grow-1" style={{ maxWidth: "400px", width: "100%" }}>
              <StyledFormGroup className="mb-0">
                <StyledFormControl
                  type="search"
                  placeholder="Search by email, name or group"
                  value={search}
                  onChange={handleSearchChange}
                />
              </StyledFormGroup>
            </div>


          </div>
        </Col>


        <CustomCol xs={12} md={3} lg={3}>
          <StyledSelect
            onChange={(e) => setStaffStatus(e.target.value)}
            value={staffStatus}
            size='sm'
            className="mb-2 mb-md-0"
          >

            {StaffStatus && StaffStatus?.map(
              ({ label, value }) => (
                <option key={label} value={value}>
                  {label}
                </option>
              )
            )}
          </StyledSelect>
        </CustomCol>

        <CustomCol xs={12} md={3} lg={3}>
          <StyledSelect
            onChange={(e) => setStaffRole(e.target.value)}
            value={staffRole}
            size='sm'
            className="mb-2 mb-md-0"
          >

            <option value="">
              All Roles
            </option>
            {adminRoles && adminRoles?.map(
              ({ name, adminRoleId }) => (
                <option key={adminRoleId} value={adminRoleId}>
                  {name}
                </option>
              )
            )}
          </StyledSelect>
        </CustomCol>

      </FilterRow>

      {/* <FilterRow>
        <div style={{ minWidth: "200px", width: "100%", maxWidth: "250px" }}>
          {customColSetting}
        </div>
      </FilterRow> */}

      <Row className="g-2 align-items-center mt-2 mt-md-0">
            <Col xs={12}>
              <div className="d-flex flex-column flex-sm-row justify-content-between gap-2 w-100">
                <div>


                  {/* Left: Reset Button */}
                  <Button
                    className="d-flex align-items-center btn-primary gap-3  w-auto"
                    style={{ height: '2.2rem', minWidth: 'max-content' }}
                    size="sm"
                    onClick={() => {
                      onHandleResetFilter()
                    }}
                  >
                    <span>Reset Filters</span>
                    <FontAwesomeIcon icon={faRedoAlt} />
                  </Button>
                </div>
                {/* Right: Download + Columns */}
                <div className="d-flex flex-column flex-sm-row gap-2 align-items-start align-items-sm-center ms-md-auto">

                  <div>
                    {customColSetting}
                  </div>

               

                </div>
              </div>
            </Col>
          </Row>
    </TableBg>
  );
};


 

export default StaffFilter;
